<template>
  <div>
    <div class="right-title">
      <span>机构列表</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-button type="primary" @click="quanBu">全部</el-button>
<!--        <el-button type="danger" @click="buXinRen" style="margin-right: 10px;">不信任</el-button>-->
        <el-button type="primary" @click="buXinRen(2)" style="margin-right: 10px;">正常</el-button>
        <el-button type="primary" @click="buXinRen(3)" style="margin-right: 10px;">未提交审核</el-button>
        <el-button type="danger" @click="buXinRen(1)" style="margin-right: 10px;">不信任</el-button>
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入关键字"
          v-model="search"
        >
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
          @selection-change="handleSelectionChange">
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="user_id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="注册手机号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="机构名称"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hals-color" @click="toDetail(scope.row.user_id)">{{scope.row.organization_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="addr"
            label="查看详情"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="hal-cursor" @click="toDetail(scope.row.user_id)">查看详情</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="addr"
            label="日志"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click="showRizhi(scope.row.user_id)" class="hal-cursor">查看日志</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_personnel_official"
            label="推荐"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.recommend"
                  active-color="#bababa"
                  inactive-color="#00a2ea"
                >
                </el-switch>
                <div class="swShade" @click="tuijian(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_personnel_official"
            label="发布动态"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.is_personnel_official"
                  active-color="#bababa"
                  inactive-color="#00a2ea"
                >
                </el-switch>
                <div class="swShade" @click="rencai(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="personnel_official_over_time"-->
<!--            label="发布动态到期"-->
<!--            align="center"-->
<!--            show-overflow-tooltip-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <span>{{scope.row.personnel_official_over_time}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="status"
            label="不信任"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.status"
                  active-color="#bababa"
                  inactive-color="#f20000"
                >
                </el-switch>
                <div class="swShade" @click="xinR(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_lock"
            label="锁定"
            align="center"
            show-overflow-tooltip
            v-if='user.admin_type === 1'>
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.user_lock"
                  active-color="#bababa"
                  inactive-color="#f20000"
                >
                </el-switch>
                <div class="swShade" @click="suoD(scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="commend"-->
          <!--            label="推荐到首页"-->
          <!--            align="center"-->
          <!--            show-overflow-tooltip-->
          <!--            v-if='user.admin_type === 1'>-->
          <!--            <template slot-scope="scope">-->
          <!--              <div class="swBox" style="position: relative;">-->
          <!--                <el-switch-->
          <!--                  v-model="scope.row.commend"-->
          <!--                  active-color="#13ce66"-->
          <!--                  inactive-color="#bababa"-->
          <!--                >-->
          <!--                </el-switch>-->
          <!--                <div class="swShade" @click="tuiJian(scope.row.user_id)"-->
          <!--                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column
            prop="addr"
            label="重置密码"
            align="center"
            show-overflow-tooltip
            v-if='user.admin_type === 1 || user.admin_type === 2'>
            <template slot-scope="scope">
              <span style="cursor: pointer" @click="chongZhi(scope.row.user_id)">重置密码</span>
            </template>
          </el-table-column>
          <el-table-column
              label="删除"
              align="center"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button size="small" type="danger" @click="delItem(scope.row.user_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div>
            <el-button type="danger" @click="addShuangxuan" v-if="user.admin_type === 1">加入一般双选会</el-button>
            <el-button type="danger" @click="addShuangxuan2" v-if="user.admin_type === 1">加入实习双选会</el-button>
            共计{{page.pageTotal}}条，已上线{{real_count}}条，待审核{{page.pageTotal- real_count}}条
            <el-button type="primary" @click="addForm" v-if="user.admin_type !== 1">添加到表单</el-button>

          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="选择一般双选会" :visible.sync="dialogFormVisible3" append-to-body>
      <el-form :model="form">
        <el-form-item label="一般双选会列表" :label-width="formLabelWidth">
          <el-select v-model="sxhValue" placeholder="请选择表单列表">
            <el-option
              v-for="item in sxhList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="addSxh">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择实习双选会" :visible.sync="dialogFormVisible4" append-to-body>
      <el-form :model="form">
        <el-form-item label="实习双选会列表" :label-width="formLabelWidth">
          <el-select v-model="sxhValue2" placeholder="请选择表单列表">
            <el-option
                v-for="item in sxhList2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="addSxh2">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="表单列表" :visible.sync="dialogFormVisible" append-to-body>
      <el-form :model="form">
        <el-form-item label="选择列表" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择表单列表">
            <el-option
              v-for="item in fList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFormSub">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请设置过期时间" :visible.sync="dialogFormVisible2" append-to-body>
      <el-form :model="form">
        <el-date-picker
          v-model="dateValue"
          type="date"
          :picker-options="pickerOptions0"
          placeholder="请设置过期时间">
        </el-date-picker>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="addRencai">确 定</el-button>
      </div>
    </el-dialog>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "jgList",
    data() {
      return {
        search: '',  // 搜索
        tableData: [],
        xinren: '',    //  不信任按钮
        multipleSelection: [], //  选中的
        dialogFormVisible: false, // 弹框下拉显示
        formList: [],
        form: {
          region: '',
          name: ''
        },
        formLabelWidth: '120px',
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
        real_count: 0,
        dialogFormVisible2: false,
        dateValue: '',     //  设置人才官日期
        setId: '',
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now();//如果没有后面的-8.64e7就是不可以选择今天的
          }
        },
        dialogFormVisible3:false,
        dialogFormVisible4:false,
        sxhList:[],
        sxhValue:'',
        sxhList2:[],
        sxhValue2:'',
      }
    },
    computed: {
      list() {
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          item.recommend = item.recommend === 0 ? (true) : (false)
          // 锁定
          item.user_lock = item.user_lock === 0 ? (true) : (false)
          // 信任
          item.status = item.status === 0 ? (true) : (false)
          //推荐
          item.commend = item.commend === 0 ? (true) : (false)
        })
        return _list
      },
      fList() {
        let flist = JSON.parse(JSON.stringify(this.formList))
        flist.map(item => {
          item.label = item.name
          item.value = item.id
        })
        return flist
      },
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 0)
      this.jgList()
      this.getSxh()
      this.getSxh2()
    },
    methods: {
      addSxh(){
        if(!this.sxhValue){
          this.$message.error('请选择双选会')
          return
        }
        let arrId = []
        this.multipleSelection.map(item => {
          arrId.push(item.user_id)
        })
        this.$api.apiContent.orgAddSXH({
          adminId: this.user.id,
          sxhId: this.sxhValue,
          orgId: arrId.join(','),
        }).then(() => {
          this.$message.success('添加成功')
          this.multipleSelection = []
          this.dialogFormVisible3 = false
        }).catch(e => {
          this.$message.error(e.info)
        })
      },
      addSxh2(){
        if(!this.sxhValue2){
          this.$message.error('请选择双选会')
          return
        }
        let arrId = []
        this.multipleSelection.map(item => {
          arrId.push(item.user_id)
        })
        this.$api.apiContent.orgAddSXH2({
          adminId: this.user.id,
          sxhId: this.sxhValue2,
          orgId: arrId.join(','),
        }).then(() => {
          this.$message.success('添加成功')
          this.multipleSelection = []
          this.dialogFormVisible4 = false
        }).catch((e) => {
          this.$message.error(e.info)
        })
      },
      getSxh(){
        this.$api.apiContent.listCustomSXH({
          page: 1,
          pageSize: 10000,
          adminId: this.user.id,
        }).then(res => {
          res.data.map(item => {
            this.sxhList.push({
              label:item.name,
              value:item.id
            })
          })
        }).catch(() => {
        })
      },
      getSxh2(){
        this.$api.apiContent.listCustomSXH2({
          page: 1,
          pageSize: 10000,
          adminId: this.user.id,
        }).then(res => {
          res.data.map(item => {
            this.sxhList2.push({
              label:item.name,
              value:item.id
            })
          })
        }).catch(() => {
        })
      },
      //  添加到双选会
      addShuangxuan() {
        if (this.multipleSelection.length > 0) {

          this.dialogFormVisible3 = true
        } else {
          this.$message.error('请选择要添加的数据');
        }


      },
      //  添加到实习双选会
      addShuangxuan2() {
        if (this.multipleSelection.length > 0) {

          this.dialogFormVisible4 = true
        } else {
          this.$message.error('请选择要添加的数据');
        }


      },
      // 添加到表单表单列表
      addForm() {
        if (this.multipleSelection.length > 0) {
          this.dialogFormVisible = true
          this.$api.apiContent.hxrAddFormList({
            type: 2,
            admin_id: this.user.id
          }).then(res => {
            this.formList = res.data
          }).catch(res => {
            this.$message.error(res.info);
          })
        } else {
          this.$message.error('请选择要添加的数据');
        }


      },
      // 添加到表单
      addFormSub() {
        this.dialogFormVisible = false
        let arrId = []
        this.multipleSelection.map(item => {
          arrId.push(item.user_id)
        })
        this.$api.apiContent.hxrAddForm({
          formid: this.form.region,
          id: arrId.join(','),
          admin_id: this.user.id
        }).then(res => {
          this.$message.success(res.info);
          this.jgList()
          this.$refs.multipleTable.clearSelection();
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      //机构详情
      toDetail(id) {
        this.$router.push({
          path: '/home/jgAdmin/jgDetail/' + id
        })
      },
      toggleSelection(rows) {     //  全选或取消全选
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      // 机构列表
      jgList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.xinren) {
          this.xinren = this.$route.query.xinren
        } else {
          this.xinren = ''
        }
        this.$api.apiContent.jgList({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          status: this.xinren,
          admin_id: this.user.id,
          is_shuangxuanhui:0
        }).then(res => {
          loading.close();

          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
          this.tableData.map(item => {
            item.is_personnel_official = item.is_personnel_official === 0 ? (true) : (false)
            item.personnel_official_over_time = item.personnel_official_over_time === -1 ? '' : this.$tools.ZHDate(new Date(item.personnel_official_over_time * 1000))
          })
          this.real_count = res.real_count
        }).catch(() => {
          loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      //  列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/jgAdmin/jgList',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
            xinren: this.xinren
          }
        })
      },
      delItem(id){
        this.$confirm('此操作将删除该机构, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.delOrgById({
            orgId: id,
            adminId: this.user.id
          }).then(res => {
            if (this.page.pageNum > 1 &&  this.list.length === 1) {
              this.page.pageNum = this.page.pageNum - 1
            } else {
              this.jgList()
            }
            this.$message({
              type: 'success',
              message: res.info
            });
          }).catch(res => {
            this.$message.error(res.info);
          })
        })
      },
      deleteList() {   //  删除选中的
        if (this.multipleSelection.length > 0) {
          let len = this.multipleSelection.length
          this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _arr = []
            this.multipleSelection.map(item => {
              _arr.push(item.user_id)
            })
            this.$api.apiContent.hxrAndjgDel({
              user_id: _arr.join(","),
              admin_id: this.user.id
            }).then(res => {
              if (this.page.pageNum > 1 && len === this.list.length) {
                this.page.pageNum = this.page.pageNum - 1
              } else {
                this.jgList()
              }
              this.$message({
                type: 'success',
                message: res.info
              });
            }).catch(res => {
              this.$message.error(res.info);
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message.error("请选中要删除的数据！");
        }
      },
      showRizhi(id) { //  查看日志
        this.$router.push({
          path: '/home/jgAdmin/jgRizhi',
          query: {
            id: id
          }
        })
      },
      chongZhi(id) { //  重置密码
        this.$confirm("此操作将重置密码，是否继续操作？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgChongz({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.gwList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //  推荐
      tuijian(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.recommend
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将推荐此机构, 是否继续?"
        } else {
          messg = "此操作将取消机构推荐, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.recommendUser({
            userId: id,
            adminId: this.user.id,
            userType:2,
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.jgList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });
        });
      },

      // 发布动态
      rencai(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.is_personnel_official
          }
        })

        let messg = ""
        if (!state) {
          // messg = "此操作将该机构可发布动态, 是否继续?"
          messg = "此操作将取消该机构发布动态权限, 是否继续?"
        } else {
          // messg = "此操作将取消该机构发布动态权限, 是否继续?"
          messg = "此操作将该机构可发布动态, 是否继续?"
          // this.dialogFormVisible2 = true
          // this.setId = id
          // return
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.setOfficialOrg({
            userId: id,
            adminId: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.jgList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {

        });
      },
      addRencai() {
        // alert(this.dateValue)
        this.$api.apiContent.setPersonnelOfficial({
          overTime: this.dateValue.getTime() / 1000,
          userId: this.setId,
          adminId: this.user.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: res.info
          });
          this.setId = ''
          this.dateValue = ''
          this.dialogFormVisible2 = false
          this.jgList()
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      //信任不信任
      xinR(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.status
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将不信任机构, 是否继续?"
        } else {
          messg = "此操作将信任机构, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgTrust({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.jgList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //锁定
      suoD(id) {
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.user_lock
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将锁定用户, 是否继续?"
        } else {
          messg = "此操作将解锁用户, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.hxrAndjgLock({
            user_id: id,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.jgList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //  推荐到首页
      tuiJian(id) {
        let state = ""
        let num = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.commend
            num = item.commend === 0 ? 1 : 0
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将不推荐到首页, 是否继续?"
        } else {
          messg = "此操作将推荐到首页, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.jgCommend({
            user_id: id,
            commend: num,
            admin_id: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.jgList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 全部按钮
      quanBu() {
        this.$router.push({
          path: '/home/jgAdmin/jgList',
          query: {
            pageNum: 1,
            key: "",
            xinren: ""
          }
        })
      },
      // 不信任按钮
      buXinRen(num) {
        this.xinren = num
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      }
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.jgList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>